import { render, staticRenderFns } from "./PikersVoice.vue?vue&type=template&id=01fe9fc5&scoped=true"
import script from "./PikersVoice.vue?vue&type=script&lang=js"
export * from "./PikersVoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe9fc5",
  null
  
)

export default component.exports